import { render, staticRenderFns } from "./class-course.vue?vue&type=template&id=1597a634&scoped=true"
import script from "./class-course.vue?vue&type=script&lang=js"
export * from "./class-course.vue?vue&type=script&lang=js"
import style0 from "./class-course.vue?vue&type=style&index=0&id=1597a634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1597a634",
  null
  
)

export default component.exports